// extracted by mini-css-extract-plugin
export default {"outer":"InlineScroll-module--outer--7079f","inner":"InlineScroll-module--inner--0acc6"};